export const tokens = {
  colors: {
    // Brand
    primary: '#1890FF',
    primaryDark: '#006EC3',
    primaryLight: '#E6F7FF',

    // Semantic
    success: '#46B774',
    error: '#F35A4E',
    warning: '#FCCA00',
    highlightYellow: '#FFF484',
    info: '#1890FF',

    // Neutrals
    text: '#111111',
    textSecondary: '#333333',
    textTertiary: '#888888',
    border: '#E8E8E8',
    bgSubtle: '#F2F2F2',
    bgWhite: '#FFFFFF',
    /** Light-blue tint for data-grid column headers, exact value from the design mock (ISS-291742). */
    bgTableHeader: '#E3F2FD',
    /** Active-tab accent (orange) for the Additional Charges Part 2 tabs, per the design mock. */
    tabActive: '#E65100',
    /** Soft green tint behind the task-progress pill on shipment cards and summary bars. */
    bgSuccessSubtle: '#EFFAF1',
    /** Soft amber tint behind the current-milestone pill on shipment cards and summary bars. */
    bgWarningSubtle: '#FEF9E9',
    /** Stronger amber tint marking an On Hold milestone. */
    bgOnHold: '#FEC89A',
  },

  spacing: {
    none: 0,
    xxs: 2,
    xs: 4,
    sm: 8,
    ms: 12,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 48,
  },

  fontSize: {
    h1: 20,
    h2: 18,
    h3: 16,
    body: 14,
    small: 12,
    caption: 10,
  },

  fontWeight: {
    regular: 400,
    semibold: 600,
    bold: 700,
  },

  fontFamily: "'Open Sans', sans-serif",

  lineHeight: {
    tight: 1.2,
    normal: 1.5,
    relaxed: 2,
  },

  shadow: {
    sm: '0 1px 3px rgba(0,0,0,0.1)',
    md: '0 4px 12px rgba(0,0,0,0.1)',
    lg: '0 8px 24px rgba(0,0,0,0.15)',
  },

  radius: {
    sm: 2,
    md: 4,
    lg: 8,
    pill: 999,
  },

  transition: {
    fast: '150ms ease',
    normal: '300ms ease',
    slow: '500ms ease',
  },

  breakpoint: {
    xs: 320,
    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1200,
    xxl: 1440,
  },

  zIndex: {
    sticky: 100,
    navbar: 200,
    dropdown: 990,
    drawer: 1000,
    modal: 1000,
    tooltip: 1060,
    toast: 1070,
  },
};

export type Tokens = typeof tokens;
